var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "default-banner main-auctions-banner"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.works, function (work) {
    return _c('div', {
      key: work._id,
      staticClass: "swiper-slide"
    }, [_c('auction-work-item', _vm._b({
      on: {
        "loaded": function loaded($event) {
          _vm.loaded += 1;
        }
      }
    }, 'auction-work-item', {
      work: work
    }, false))], 1);
  }), 0), _vm._m(0)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "swiper-control"
  }, [_c('div', {
    staticClass: "swiper-prev"
  }, [_c('i', {
    staticClass: "icon icon-arrow-left mr-6"
  }), _c('span', [_vm._v("PREV")])]), _c('div', {
    staticClass: "swiper-pagination"
  }), _c('div', {
    staticClass: "swiper-next"
  }, [_c('span', [_vm._v("NEXT")]), _c('i', {
    staticClass: "icon icon-arrow-right ml-6"
  })])]);
}]

export { render, staticRenderFns }